import { ethers } from "ethers";
import abi from "./abi";
// import { address } from "./minting";

const ADDRESS = "0xD1f49F4882860bB311ff549F4393B9AdAa82Ab64";

export default async function showRemainingSupply() {
	const provider = ethers.getDefaultProvider();
	if (await provider.ready) {
		// you should check if provider is ready then only to proceed the next task
		const contract = new ethers.Contract(ADDRESS, abi, provider);
		const tokensMinted = await contract._tokenId();
		// const maxSupply = await contract.getMaxSupply();
		// const num = ethers.utils.formatUnits(maxSupply, 0) - ethers.utils.formatUnits(tokensMinted, 0);
		return tokensMinted;
	}
	return "---";
}

export async function getMaxSupply() {
	const provider = ethers.getDefaultProvider();
	if (await provider.ready) {
		// you should check if provider is ready then only to proceed the next task
		const contract = new ethers.Contract(ADDRESS, abi, provider);
		const maxSupply = await contract.getMaxSupply();
		const num = ethers.utils.formatUnits(maxSupply, 0);
		return num;
	}
	return "---";
}
